import type { ReactElement } from 'react';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BadgeIcon from '@mui/icons-material/Badge';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { policyModule } from './policy';
import { costCenterModule } from './costCenter';
import { departmentModule } from './department';
import { titleModule } from './title';

/**
 * CORPORATE ORG-STRUCTURE admin screens (Policy / CostCenter / Department / Title) —
 * migration guide Bölüm 3.9, 4.12 & 5.3 (Kurumsal section). One combined module
 * aggregating the 4 independent sub-modules' routes/menuItems so app/modules.ts only ever
 * imports a single `corporateOrgModule`, matching every other module's one-line footprint
 * there. Each sub-module's own index.tsx already gates its menu item behind `HasKurumsal`;
 * icons are attached here rather than per-sub-module so the sub-modules stay icon-agnostic
 * and reusable if ever surfaced outside this aggregator.
 */
const withIcons: Record<string, ReactElement> = {
  'corporate/policy': <RuleFolderIcon />,
  'corporate/cost-center': <AccountBalanceWalletIcon />,
  'corporate/department': <AccountTreeIcon />,
  'corporate/title': <BadgeIcon />,
};

const subModules: ModuleDefinition[] = [policyModule, costCenterModule, departmentModule, titleModule];

export const corporateOrgModule: ModuleDefinition = {
  routes: subModules.flatMap((m) => m.routes),
  menuItems: subModules.flatMap((m, moduleIdx) =>
    m.menuItems.map((item, itemIdx) => ({
      ...item,
      label: item.label.replace(/^Kurumsal:\s*/, ''),
      icon: item.icon ?? withIcons[item.path],
      group: 'Kurumsal',
      groupIcon: moduleIdx === 0 && itemIdx === 0 ? <CorporateFareOutlinedIcon /> : undefined,
    }))
  ),
};
